import * as A from '@digital-bridge/artisan-arya';

export type FurnitureDescription = A.FurnitureDescription;

export function articlesFromFurnitureDescription(furniture: FurnitureDescription): string[] {
    return furniture.variants
        .map(product => product.articles)
        .reduce((acc, cur) => acc.concat(Object.keys(cur)), [] as string[]);
}
